import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
export default class JavertFormatModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "result", null);
    _defineProperty(this, "activeTab", 'preview');
    // 'preview' | 'markdown'
    _defineProperty(this, "error", null);
  }
  className() {
    return 'JavertFormatModal Modal--large';
  }
  title() {
    return '🪄 Asistente de Formato — Zurigorris y Vascos';
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.analyzeText();
  }
  async analyzeText() {
    this.loading = true;
    this.error = null;
    m.redraw();
    const requestBody = {};
    if (this.attrs.post) {
      requestBody.postId = this.attrs.post.id();
    } else if (this.attrs.textEditor) {
      const editor = this.attrs.textEditor;
      let text = '';
      if (typeof editor.value === 'function') {
        text = editor.value();
      } else if (typeof editor.value === 'string') {
        text = editor.value;
      } else if (editor.attrs && typeof editor.attrs.value === 'function') {
        text = editor.attrs.value();
      } else if (editor.attrs && typeof editor.attrs.value === 'string') {
        text = editor.attrs.value;
      }
      requestBody.text = text;
    }
    if (!requestBody.postId && (!requestBody.text || !requestBody.text.trim())) {
      this.loading = false;
      this.error = 'No se ha proporcionado texto ni post para formatear.';
      m.redraw();
      return;
    }
    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/nagusi/format-assistant/parse',
        body: requestBody
      });
      this.result = response;
      this.loading = false;
      m.redraw();
    } catch (err) {
      var _err$response;
      this.loading = false;
      this.error = ((_err$response = err.response) == null ? void 0 : _err$response.error) || err.message || 'Error al analizar el post.';
      m.redraw();
    }
  }
  applyFormattedText() {
    var _this$result;
    if (!((_this$result = this.result) != null && _this$result.formatted_markdown)) {
      return;
    }
    if (this.attrs.post) {
      this.saving = true;
      m.redraw();
      this.attrs.post.save({
        content: this.result.formatted_markdown
      }).then(() => {
        this.saving = false;
        app.modal.close();
        app.alerts.show({
          type: 'success'
        }, '¡Post formateado y actualizado con éxito!');
        m.redraw();
      }).catch(err => {
        this.saving = false;
        this.error = err.message || 'Error al guardar los cambios del post.';
        m.redraw();
      });
      return;
    }
    if (this.attrs.textEditor) {
      const editor = this.attrs.textEditor;
      if (typeof editor.setValue === 'function') {
        editor.setValue(this.result.formatted_markdown);
      } else if (typeof editor.value === 'function') {
        editor.value(this.result.formatted_markdown);
      }
      app.modal.close();
      app.alerts.show({
        type: 'success'
      }, '¡Texto formateado en el editor!');
    }
  }
  content() {
    var _this$result$detected, _this$result$detected2, _this$result$unmatche, _this$result$detected3, _this$result$detected4, _this$result2;
    return m("div", {
      className: "Modal-body JavertFormatModal-body"
    }, this.loading && m("div", {
      className: "JavertFormatModal-loading",
      style: "text-align: center; padding: 40px 20px;"
    }, m(LoadingIndicator, null), m("p", {
      style: "margin-top: 15px; font-weight: 500; color: var(--muted-color);"
    }, "Analizando post, detectando escudos de rivales y fotos de jugadores...")), !this.loading && this.error && m("div", {
      className: "Alert Alert--error",
      style: "margin-bottom: 20px;"
    }, m("i", {
      className: "fas fa-exclamation-circle",
      style: "margin-right: 8px;"
    }), this.error), !this.loading && this.result && m("div", {
      className: "JavertFormatModal-container"
    }, m("div", {
      className: "JavertFormatModal-summary-bar"
    }, m("div", {
      className: "JavertFormatModal-badge-type"
    }, m("strong", null, "Tipo detectado:"), ' ', m("span", {
      className: "Badge Badge--primary"
    }, this.result.detected_type === 'zdp' ? 'Zurigorris de Plata (Segunda / RFEF)' : 'Vascos por el Mundo')), m("div", {
      className: "JavertFormatModal-tabs"
    }, m("button", {
      type: "button",
      className: "Button Button--link ".concat(this.activeTab === 'preview' ? 'active font-weight-bold' : ''),
      onclick: () => {
        this.activeTab = 'preview';
      }
    }, m("i", {
      className: "fas fa-eye",
      style: "margin-right: 6px;"
    }), " Vista Previa"), m("button", {
      type: "button",
      className: "Button Button--link ".concat(this.activeTab === 'markdown' ? 'active font-weight-bold' : ''),
      onclick: () => {
        this.activeTab = 'markdown';
      }
    }, m("i", {
      className: "fas fa-code",
      style: "margin-right: 6px;"
    }), " Markdown"))), m("div", {
      className: "JavertFormatModal-grid"
    }, m("div", {
      className: "JavertFormatModal-sidebar"
    }, this.result.detected_type === 'zdp' && m("div", {
      className: "JavertFormatModal-section"
    }, m("h4", {
      className: "JavertFormatModal-section-title"
    }, m("i", {
      className: "fas fa-shield-alt",
      style: "color: var(--primary-color); margin-right: 6px;"
    }), "Equipos con Escudo (", ((_this$result$detected = this.result.detected_rivals) == null ? void 0 : _this$result$detected.length) || 0, ")"), m("div", {
      className: "JavertFormatModal-item-list"
    }, (_this$result$detected2 = this.result.detected_rivals) == null ? void 0 : _this$result$detected2.map(rival => m("div", {
      className: "JavertFormatModal-item",
      key: rival.name
    }, rival.escudo_url ? m("img", {
      src: rival.escudo_url,
      alt: "",
      className: "JavertFormatModal-crest-thumb"
    }) : m("i", {
      className: "fas fa-shield-alt",
      style: "color: var(--muted-color); font-size: 1.1em;"
    }), m("span", {
      className: "JavertFormatModal-item-name"
    }, rival.name), m("i", {
      className: "fas fa-check-circle text-success",
      style: "margin-left: auto; font-size: 0.85em;"
    }))), (!this.result.detected_rivals || this.result.detected_rivals.length === 0) && m("p", {
      className: "helpText"
    }, "No se han detectado equipos de Segunda/RFEF."))), ((_this$result$unmatche = this.result.unmatched_rivals) == null ? void 0 : _this$result$unmatche.length) > 0 && m("div", {
      className: "JavertFormatModal-section JavertFormatModal-warning-section"
    }, m("h4", {
      className: "JavertFormatModal-section-title text-warning"
    }, m("i", {
      className: "fas fa-exclamation-triangle",
      style: "margin-right: 6px;"
    }), "Sin escudo en base de datos (", this.result.unmatched_rivals.length, ")"), m("div", {
      className: "JavertFormatModal-item-list"
    }, this.result.unmatched_rivals.map(name => m("div", {
      className: "JavertFormatModal-item JavertFormatModal-item--unmatched",
      key: name
    }, m("i", {
      className: "fas fa-question-circle",
      style: "color: #e67e22; margin-right: 8px;"
    }), m("span", {
      className: "JavertFormatModal-item-name"
    }, name)))), m("p", {
      className: "helpText",
      style: "font-size: 0.8em; margin-top: 6px;"
    }, "Aparecer\xE1n con icono de escudo gen\xE9rico sin romper el formato.")), m("div", {
      className: "JavertFormatModal-section"
    }, m("h4", {
      className: "JavertFormatModal-section-title"
    }, m("i", {
      className: "fas fa-user-check",
      style: "color: var(--primary-color); margin-right: 6px;"
    }), "Jugadores con Foto (", ((_this$result$detected3 = this.result.detected_players) == null ? void 0 : _this$result$detected3.length) || 0, ")"), m("div", {
      className: "JavertFormatModal-item-list"
    }, (_this$result$detected4 = this.result.detected_players) == null ? void 0 : _this$result$detected4.map(p => m("div", {
      className: "JavertFormatModal-item",
      key: p.name
    }, p.photo_url ? m("img", {
      src: p.photo_url,
      alt: "",
      className: "JavertFormatModal-player-thumb"
    }) : m("i", {
      className: "fas fa-user",
      style: "color: var(--muted-color);"
    }), m("span", {
      className: "JavertFormatModal-item-name"
    }, p.name))), (!this.result.detected_players || this.result.detected_players.length === 0) && m("p", {
      className: "helpText"
    }, "No se vincularon jugadores con foto.")))), m("div", {
      className: "JavertFormatModal-preview-container"
    }, this.activeTab === 'preview' ? m("div", {
      className: "JavertFormatModal-preview-content Post-body"
    }, m.trust(this.result.rendered_html)) : m("div", {
      className: "JavertFormatModal-markdown-content"
    }, m("textarea", {
      className: "FormControl JavertFormatModal-textarea",
      readonly: true,
      rows: 20,
      value: this.result.formatted_markdown
    }))))), m("div", {
      className: "JavertFormatModal-footer",
      style: "display: flex; justify-content: space-between; align-items: center; margin-top: 25px; padding-top: 15px; border-top: 1px solid rgba(255,255,255,0.1);"
    }, m(Button, {
      className: "Button Button--link",
      onclick: () => app.modal.close(),
      disabled: this.saving
    }, "Cancelar y mantener original"), m("div", {
      style: "display: flex; gap: 10px;"
    }, m(Button, {
      className: "Button Button--secondary",
      icon: "fas fa-sync-alt",
      onclick: () => this.analyzeText(),
      disabled: this.loading || this.saving
    }, "Reanalizar"), m(Button, {
      className: "Button Button--primary",
      icon: this.saving ? 'fas fa-spinner fa-spin' : 'fas fa-magic',
      onclick: () => this.applyFormattedText(),
      disabled: this.loading || this.saving || !((_this$result2 = this.result) != null && _this$result2.formatted_markdown)
    }, this.attrs.post ? '🪄 Aplicar y Guardar Post' : '🪄 Aplicar al Editor'))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/format-assistant/JavertFormatModal', JavertFormatModal);